



























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { Party } from '@/stores/party/types';
import Paginator from '@/components/Paginator.vue';
import { PaginatorEvent, Comment, Contact, Attachment } from '@/types';
import { PartyStatusColor, ClaimStatusColor } from '@/enums';
import { PartyState, PartyCommentPaginator, PartyContactPaginator } from '@/stores/party/types';
import NewCommentModal from '@/components/modals/NewCommentModal.vue';
import NewContactModal from '@/components/modals/NewContactModal.vue';
import { partyService } from '@/services/party.services';

const namespace: string = 'party';

@Component({
    components: {
        Paginator,
        NewCommentModal,
        NewContactModal,
    },
})
export default class PartyView extends Vue {
    @State('party') partyState!: PartyState;
    @Action('get', { namespace }) getPartyData: any;
    @Action('updateParty', { namespace }) updatePartyData: any;
    @Action('postComment', { namespace }) postCommentData: any;
    @Action('getComments', { namespace }) getPartyComments: any;
    @Action('postContact', { namespace }) postContactData: any;
    @Action('getContacts', { namespace }) getPartyContacts: any;
    @Getter('comments', { namespace }) partyComments!: PartyCommentPaginator;
    @Getter('contacts', { namespace }) partyContacts!: PartyContactPaginator;
    @Getter('attachments', { namespace }) partyAttachments!: Attachment[];
    @Getter('party', { namespace }) partyData!: Party;

    claimFields: any = [
        {
            label: 'Defender',
            key: 'defender.name',
            sortable: true,
        },
        {
            label: 'Offender',
            key: 'offender.name',
            sortable: true,
        },
        {
            key: 'amount',
            label: 'Amount',
            sortable: true,
        },
        {
            key: 'status',
            label: 'Status',
            sortable: true,
        },
        {
            label: 'Assignee',
            key: 'assignee.name',
            sortable: true,
        },
        {
            key: 'actions',
            label: 'Actions',
        },
    ];

    contactFields: any = [
        {
            key: 'name',
            label: 'Name',
        },
        {
            key: 'email',
            label: 'Email',
        },
        {
            key: 'phone',
            label: 'Phone',
        },
        {
            key: 'actions',
            label: 'Actions',
        },
    ];

    Commentfields: any = [
        {
            key: 'inserted_at',
            label: 'Date',
            sortable: true,
        },
        {
            key: 'comment',
            label: 'Comment',
            sortable: true,
        },
        {
            label: 'Created By',
            key: 'user.name',
            sortable: true,
        },
        {
            key: 'actions',
            label: 'Actions',
        },
    ];

    attachmentFields: any = [
        {
            label: 'Comment',
            key: 'comment.comment',
            sortable: true,
        },
        {
            key: 'filename',
            label: 'Filename',
            sortable: true,
            tdClass: 'handCursor',
        },
        {
            key: 'actions',
            label: 'Actions',
        },
    ];

    currentCommentPage: any = 1;
    commentsPerPage: any = 10;

    editComment: Comment = {
      comment: '',
    };

    editContact: Contact = {
            name: '',
            email: '',
            phone: '',
    };

    updateComments() {
        this.getPartyComments({
            id: this.$route.params.id,
            page: this.currentCommentPage,
            perPage: this.commentsPerPage,
        });
    }

    updatePaginate(paginatorObject: PaginatorEvent) {
        this.commentsPerPage = paginatorObject.perPage;
        this.currentCommentPage = paginatorObject.currentPage;
        this.updateComments();
    }

    mounted() {
        this.getPartyData({id: this.$route.params.id});
    }

    get comments() {
        return this.partyComments && this.partyComments.data;
    }

    get commentsPages() {
        return this.partyComments && this.partyComments.metadata;
    }

    get contacts() {
        return this.partyContacts && this.partyContacts.data;
    }

    get contactsPages() {
        return this.partyContacts && this.partyContacts.metadata;
    }

    get party() {
        return this.partyData && this.partyData;
    }

    get attachments() {
      return this.partyAttachments;
    }

    statusColor(status: 'ACTIVE'|'INACTIVE') {
      return PartyStatusColor[status];
    }

    openNewPartyCommentModal() {
        this.editComment = {
            comment: '',
        };
        this.$nextTick(() => {
            ((this.$refs.newCommentModalRef) as any).showModal();
        });
    }

    openEditPartyCommentModal(comment: Comment) {
        this.editComment = comment;
        this.$nextTick(() => {
            ((this.$refs.newCommentModalRef) as any).showModal();
        });
    }

    saveNewComment(comment: Comment) {
        this.postCommentData({
            id: this.party.id,
            comment,
            page: this.currentCommentPage,
            perPage: this.commentsPerPage,
        });
    }

    openNewPartyContactModal() {
        this.editContact = {
            name: '',
            email: '',
            phone: '',
        };
        this.$nextTick(() => {
          ((this.$refs.newContactModalRef) as any).showModal();
        });
    }

    openEditPartyContactModal(id: number) {
        this.editContact = this.contacts[id];
        this.$nextTick(() => {
            ((this.$refs.newContactModalRef) as any).showModal();
        });
    }

    saveNewContact(contact: Contact) {
        this.postContactData({
            id: this.party.id,
            contact,
        });
    }


    downloadAttachment(id: string, filename: string) {
      partyService.downloadAttachment(id, filename);
    }

    openNewClaimCommentModal() {
        ((this.$refs.newCommentModalRef) as any).showModal();
    }

    onRowClicked(item: any, index: number, event: Event) {
        this.$router.push({ name: 'claim', params: { id: item.id } });
    }

    setPrimaryContact(index: number) {
        this.party.primary_contact_id = this.contacts[index].id;
        this.updatePartyData({
            party: this.party,
        });
    }
}
